import React from 'react';
import { Briefcase, Calendar, Plus, Edit2, Trash2 } from 'lucide-react';

export default function ExperienceSection({
    t,
    portfolio,
    currentLang,
    getText,
    isAdmin,
    showAddExperience,
    setShowAddExperience,
    newExperience,
    setNewExperience,
    addExperience,
    handleEditExperience,
    deleteExperience,
    editingExperienceId,
    setEditingExperienceId
}) {
    // Helper to handle array inputs for description
    const handleExperienceDescChange = (lang, index, value) => {
        const updatedDesc = { ...newExperience.description };
        updatedDesc[lang] = [...updatedDesc[lang]];
        updatedDesc[lang][index] = value;
        setNewExperience({ ...newExperience, description: updatedDesc });
    };

    const addExperienceDescLine = (lang) => {
        const updatedDesc = { ...newExperience.description };
        updatedDesc[lang] = [...updatedDesc[lang], ''];
        setNewExperience({ ...newExperience, description: updatedDesc });
    };

    const removeExperienceDescLine = (lang, index) => {
        const updatedDesc = { ...newExperience.description };
        updatedDesc[lang] = updatedDesc[lang].filter((_, i) => i !== index);
        setNewExperience({ ...newExperience, description: updatedDesc });
    };

    return (
        <section id={t.nav[2].toLowerCase().replace(/\s+/g, '-')} className="py-24 px-4 bg-slate-900/50">
            <div className="max-w-4xl mx-auto">
                <div className="flex justify-between items-center mb-16">
                    <h2 className="text-4xl md:text-5xl font-bold text-center flex-1">
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-500">
                            {t.experience}
                        </span>
                    </h2>
                    {isAdmin && (
                        <button onClick={() => {
                            setNewExperience({
                                title: { es: '', pt: '', en: '' },
                                company: '',
                                period: '',
                                description: { es: [''], pt: [''], en: [''] }
                            });
                            setEditingExperienceId(null);
                            setShowAddExperience(true);
                        }} className="bg-cyan-500/20 text-cyan-400 p-2 rounded-lg hover:bg-cyan-500 hover:text-white transition-all">
                            <Plus size={24} />
                        </button>
                    )}
                </div>

                {/* Add/Edit Experience Form */}
                {showAddExperience && (
                    <div className="bg-slate-800 p-8 rounded-2xl mb-12 border border-slate-700 animate-fade-in-up">
                        <h3 className="text-xl font-bold mb-6 text-white border-b border-slate-700 pb-2">{editingExperienceId ? 'Editar Experiencia' : 'Agregar Experiencia'}</h3>
                        <div className="space-y-4">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                                <input type="text" placeholder="Cargo (ES)" value={newExperience.title.es} onChange={(e) => setNewExperience({ ...newExperience, title: { ...newExperience.title, es: e.target.value } })} className="bg-slate-900 border border-slate-700 rounded-lg p-3" />
                                <input type="text" placeholder="Cargo (PT)" value={newExperience.title.pt} onChange={(e) => setNewExperience({ ...newExperience, title: { ...newExperience.title, pt: e.target.value } })} className="bg-slate-900 border border-slate-700 rounded-lg p-3" />
                                <input type="text" placeholder="Cargo (EN)" value={newExperience.title.en} onChange={(e) => setNewExperience({ ...newExperience, title: { ...newExperience.title, en: e.target.value } })} className="bg-slate-900 border border-slate-700 rounded-lg p-3" />
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <input type="text" placeholder="Empresa" value={newExperience.company} onChange={(e) => setNewExperience({ ...newExperience, company: e.target.value })} className="bg-slate-900 border border-slate-700 rounded-lg p-3" />
                                <input type="text" placeholder="Período" value={newExperience.period} onChange={(e) => setNewExperience({ ...newExperience, period: e.target.value })} className="bg-slate-900 border border-slate-700 rounded-lg p-3" />
                            </div>

                            {/* Description Lines per Language */}
                            {['es', 'pt', 'en'].map(lang => (
                                <div key={lang} className="bg-slate-900/50 p-4 rounded-lg border border-slate-800">
                                    <h4 className="text-sm font-semibold text-slate-400 mb-2 uppercase">Descripción ({lang.toUpperCase()})</h4>
                                    {newExperience.description[lang].map((line, idx) => (
                                        <div key={idx} className="flex gap-2 mb-2">
                                            <input
                                                type="text"
                                                value={line}
                                                onChange={(e) => handleExperienceDescChange(lang, idx, e.target.value)}
                                                className="flex-1 bg-slate-900 border border-slate-700 rounded-lg p-2 text-sm"
                                                placeholder={`Línea ${idx + 1}`}
                                            />
                                            <button onClick={() => removeExperienceDescLine(lang, idx)} className="text-red-500 hover:bg-red-500/10 p-2 rounded"><Trash2 size={16} /></button>
                                        </div>
                                    ))}
                                    <button onClick={() => addExperienceDescLine(lang)} className="text-sm text-cyan-400 hover:text-cyan-300 flex items-center gap-1 mt-2">
                                        <Plus size={14} /> Agregar línea
                                    </button>
                                </div>
                            ))}

                            <div className="flex gap-4 pt-4">
                                <button onClick={addExperience} className="flex-1 bg-cyan-600 hover:bg-cyan-500 text-white py-3 rounded-lg transition-colors font-bold">
                                    {editingExperienceId ? 'Actualizar' : t.save}
                                </button>
                                <button onClick={() => { setShowAddExperience(false); setEditingExperienceId(null); }} className="flex-1 bg-slate-700 hover:bg-slate-600 px-4 rounded-lg transition-colors">{t.cancel}</button>
                            </div>
                        </div>
                    </div>
                )}


                <div className="space-y-12 relative before:absolute before:left-4 md:before:left-1/2 before:top-0 before:bottom-0 before:w-0.5 before:bg-gradient-to-b before:from-cyan-500 before:via-blue-500 before:to-purple-500 before:opacity-30">
                    {portfolio.experience.map((job, index) => (
                        <div key={job.id} className={`relative flex flex-col md:flex-row gap-8 items-center md:items-start ${index % 2 === 0 ? 'md:flex-row-reverse' : ''} animate-on-scroll opacity-0 translate-y-10 transition-all duration-1000`}>
                            {/* Dot */}
                            <div className="absolute left-4 md:left-1/2 -ml-[9px] w-5 h-5 rounded-full bg-slate-900 border-4 border-cyan-500 z-10"></div>

                            <div className="w-full md:w-1/2 pl-12 md:pl-0">
                                <div className={`bg-slate-800/50 p-8 rounded-2xl border border-slate-700 hover:border-cyan-500/50 transition-all duration-300 group hover:-translate-y-1 relative ${index % 2 === 0 ? 'md:mr-12' : 'md:ml-12'}`}>
                                    {isAdmin && (
                                        <div className="absolute top-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                            <button onClick={() => handleEditExperience(job)} className="bg-slate-700 p-2 rounded-lg text-cyan-400 hover:text-white hover:bg-cyan-600 transition-colors">
                                                <Edit2 size={16} />
                                            </button>
                                            <button onClick={() => deleteExperience(job.id)} className="bg-slate-700 p-2 rounded-lg text-red-400 hover:text-white hover:bg-red-600 transition-colors">
                                                <Trash2 size={16} />
                                            </button>
                                        </div>
                                    )}

                                    <div className="flex items-center gap-3 mb-4 text-cyan-400">
                                        <Briefcase size={20} />
                                        <h3 className="text-xl font-bold text-white">{getText(job.title, currentLang)}</h3>
                                    </div>
                                    <div className="flex items-center gap-2 text-slate-400 mb-6 text-sm">
                                        <Calendar size={16} />
                                        <span>{job.period}</span>
                                        <span className="w-1 h-1 rounded-full bg-slate-500 mx-2"></span>
                                        <span>{job.company}</span>
                                    </div>
                                    <ul className="space-y-3">
                                        {Array.isArray(getText(job.description, currentLang)) ? (
                                            getText(job.description, currentLang).map((desc, i) => (
                                                <li key={i} className="text-slate-300 flex items-start gap-3">
                                                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-cyan-500 flex-shrink-0"></span>
                                                    <span className="leading-relaxed">{desc}</span>
                                                </li>
                                            ))
                                        ) : (
                                            // Fallback if update hasn't migrated data structure locally yet
                                            <li className="text-slate-300 flex items-start gap-3">
                                                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-cyan-500 flex-shrink-0"></span>
                                                <span className="leading-relaxed">{typeof getText(job.description, currentLang) === 'string' ? getText(job.description, currentLang) : ''}</span>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
